import Layout from "components/structure/Layout";
import React, { useCallback } from "react";
import AccessTable from "../Common/AccessTable";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import Delegation from "assets/delegation.svg";
import ConflictIndicator from "assets/conflict_indicator.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RoleService from "services/RoleService";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import UserCreationService from "services/UserCreationService";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { AuthData } from "auth/AuthWarpper";
import { useTranslation } from "react-i18next";

const UserCreation = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [data, setData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await UserCreationService.getUserCreation();

      const responseData = response.data.response;

      const rows = responseData.map((item) => ({
        userId: item.userId,
        batOneId: item.batOneId,
        profileCode: item.profileCode,
        profileName: item.profileName,
        profileId: item.profileId,
        profileAttribute: item.profileAttribute,
        countryCode: item.countryCode,
        countryName: item.countryName,
        email: item.email,
        active: item.active === true ? "Active" : "InActive",
        isDeleted: item.isDeleted,
        createdByUser: item.createdByUser,
        modifiedDateTimeUTC: item.modifiedDateTimeUTC,
        modifiedByUser: item.modifiedByUser,
        userName: item.userName,
        startDate: item.startDate,
        endDate: item.endDate,
        remarks: item.remarks,
        serviceNumber: item.serviceNumber,
      }));

      // "userId": "e7e06b07-b401-458a-8724-7732b147c38d",
      // "userName": "Rahul Dutta",
      // "profileId": "0a2a910c-922e-1786-8192-2ea2843f0004",
      // "profileName": "Role_Test_002",
      // "profileAttribute": "Local",
      // "batOneId": 85189949,
      // "countryCode": "KEN",
      // "countryName": "Kenya",
      // "email": "",
      // "active": false,
      // "startDate": "2024-10-07T09:56:19.007+00:00",
      // "endDate": "2024-10-16T18:30:00.000+00:00",
      // "serviceNumber": "3323",
      // "remarks": "nlp",
      // "isDeleted": false,
      // "createdDateTimeUTC": "2024-10-07T09:56:19.007Z",
      // "createdByUser": "Rahul Dutta",
      // "modifiedDateTimeUTC": "2024-10-07T09:56:19.007Z",
      // "modifiedByUser": "Rahul Dutta"

      //   {
      //     "userId": "e7e06b07-b401-458a-8724-7732b147c38d",
      //     "userName": "Rahul Dutta",
      //     "profileId": "99247bae-e30a-4106-b198-e74e2ce55d26",
      //     "profileName": "Global Admin",
      //     "profileAttribute": "Global",
      //     "batOneId": 85189949,
      //     "countryCode": "KEN",
      //     "countryName": "Kenya",
      //     "email": "rahul.dutta@itcinfotech.com",
      //     "active": true,
      //     "isDeleted": false,
      //     "createdDateTimeUTC": "2024-05-14T09:32:51.543Z",
      //     "createdByUser": "ADMIN",
      //     "modifiedDateTimeUTC": "2024-10-04T11:19:29.590Z",
      //     "modifiedByUser": "Rahul Dutta"
      // },
      setData(rows);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchResults = useCallback(
    debounce(async (query) => {
      setLoading(true);
      try {
        const response = await UserCreationService.searchUser(query);
        const responseData = response.data.response;

        const rows = responseData.map((item) => ({
          userId: item.userId,
          batOneId: item.batOneId,
          profileCode: item.profileCode,
          profileName: item.profileName,
          profileId: item.profileId,
          profileAttribute: item.profileAttribute,
          countryCode: item.countryCode,
          countryName: item.countryName,
          email: item.email,
          active: item.active === true ? "Active" : "InActive",
          isDeleted: item.isDeleted,
          createdByUser: item.createdByUser,
          modifiedDateTimeUTC: item.modifiedDateTimeUTC,
          modifiedByUser: item.modifiedByUser,
          userName: item.userName,
          startDate: item.startDate,
          endDate: item.endDate,
          remarks: item.remarks,
          serviceNumber: item.serviceNumber,
        }));

        setData(rows);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setData([]);
        setLoading(false);
      }
    }, 500), // 500ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
      fetchResults(query);
  };

  const columns = [
    { label: t("userCreation.name"), field: "userName", align: "left" },
    { label: t("batOneId"), field: "batOneId", align: "left" },
    { label: t("country"), field: "countryName", align: "left" },
    { label: t("userCreation.roleName"), field: "profileName", align: "left" },
    { label: t("Status"), field: "active", align: "left" },
    { label: t("Action"), field: "action", align: "left" },
  ];

  const handleDelegation = () => {
    const batOneId = user?.batOneId;
    RoleService.fetchDelegation(batOneId)
      .then((res) => {
        navigate("/Delegationupdate", {
          state: {
            rowData: { data: res?.data?.response, fromUrl: "UserCreation" },
          },
        });
      })
      .catch((error) => {
        console.error("API call failed:", error);
        navigate("/ownAndOthersDelegation", {
          state: { fromUrl: "userCreation" },
        });
      });
  };
  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box>
              <TextField
                sx={{ width: "403px" }}
                fullWidth
                value={searchQuery}
                onChange={handleSearch}
                placeholder={t("search")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={() => navigate("/conflictIndicator")}
                // variant="outlined"
                sx={{
                  pt: "6px",
                  pr: "15px",
                  pb: "6px",
                  pl: "15px",
                  background: "#ffffff",
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: "0.739px solid #FFF",
                  color: "#0A3575",
                  fontSize: "20.696px",
                  fontFamily: "Montserrat",
                  textTransform: "capitalize",
                  fontWeight: "500",
                }}
                startIcon={
                  <img src={ConflictIndicator} alt="Conflict Indicator" />
                }
              >
                {t("userCreation.conflictIndicator")}
              </Button>
              <Button
                // variant="outlined"
                sx={{
                  pt: "6px",
                  pr: "15px",
                  pb: "6px",
                  pl: "15px",
                  background: "#ffffff",
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: "0.739px solid #FFF",
                  color: "#0A3575",
                  fontSize: "20.696px",
                  fontFamily: "Montserrat",
                  textTransform: "capitalize",
                  fontWeight: "500",
                }}
                startIcon={<img src={Delegation} alt="delegation" />}
              onClick={() => navigate('/otherDelegation', { state: { fromUrl: "userCreation" } })}

              >
                {t("delegation")}
              </Button>
              <Button
                // variant="outlined"
                onClick={() => navigate("/addUser")}
                sx={{
                  pt: "6px",
                  pr: "15px",
                  pb: "6px",
                  pl: "15px",
                  background: "#ffffff",
                  boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                  border: "0.739px solid #FFF",
                  color: "#0A3575",
                  fontSize: "20.696px",
                  fontFamily: "Montserrat",
                  textTransform: "capitalize",
                  fontWeight: "500",
                }}
                startIcon={<img src={AddButton} alt="add" />}
              >
                {t("addNewUser")}
              </Button>
            </Box>
          </Box>

          <AccessTable
            columns={columns}
            rows={data}
            url={"/editUserCreation"}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 5,
                mb: 2,
              }}
            >
              {user?.profileName == "IT Admin Access Mgt" && (
                <Button
                  sx={{
                    borderRadius: 2,
                    background: "#EF7D00",
                    color: "#ffffff",
                    fontWeight: 600,
                    height: 54,
                    width: { xs: "100%", md: "156px" },
                    "&:hover": {
                      backgroundColor: "#EF7D00",
                    },
                  }}
                  onClick={() =>
                    navigate("/export", {
                      state: "user",
                      profileInfo: user?.profileAttribute,
                      extractType: "user",
                    })
                  }
                >
                  {t("export")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default UserCreation;
